import { inject, type App } from "vue";

export async function loadIcons(
	icons: Record<string, string>,
	app: App<Element>,
) {
	const result = Object.entries(icons)
		.map(([path, icon]) => [path.match(/([^/]+)\.svg$/)?.[1] ?? "", icon])
		.filter(([name]) => !!name);
	app.provide("icons", Object.fromEntries(result));
}
export function useIconSrc(name: string) {
	return inject<Record<string, string>>("icons")?.[name] ?? "";
}
